import { defineFetch } from 'resift';
import SourceType from 'types/Source';
import Directory from 'types/Directory';

export default defineFetch({
  displayName: 'Get All Source Mappings From Directory',
  make: (directoryId: string) => ({
    key: [directoryId],
    request: (directory: Directory, currentSourceId: string) => async ({ http }) => {
      const { sources } = directory;

      const sourcesWithoutCurrentSource = sources.filter(
        (source: SourceType) => source.id !== currentSourceId,
      );

      const allSourceMappings = await Promise.all(
        sourcesWithoutCurrentSource.map(({ id }: any) => {
          return http({
            method: 'GET',
            route: '/source-mappings',
            query: { sourceId: id },
          });
        }),
      );

      return allSourceMappings.reduce((acc: any[], sourceMapping: any, index) => {
        const parentSource = sourcesWithoutCurrentSource[index];

        const newSourceMapping = sourceMapping.map((sourceMapping: any) => ({
          ...sourceMapping,
          fromSource: parentSource.label,
        }));

        return [...newSourceMapping, ...acc];
      }, []);
    },
  }),
});
